export const unregisterSessionAbort = (config) => {
  if (config && typeof config.__unregisterSessionAbort === 'function') {
    config.__unregisterSessionAbort();
  }
};
